export default __webpack_public_path__ + "static/media/edit.46f9831c.svg";